window.addEventListener('load', event => {
    let containMe = document.querySelectorAll('.contain-me');

    for (let container of containMe) {
        let parentContainer = container.closest('section');
        let containsContainMe = container.closest('.contains-contained-child');

        if (parentContainer) {
            let throttleResize =  _throttle(setMediaHeight, 500, {leading: false, trailing: true});
            window.addEventListener('resize', throttleResize, {passive: true})

            setMediaHeight();

            setTimeout(() => {
                setMediaHeight();
            }, 1000);

            function setMediaHeight() {
                let mediaQuery = window.matchMedia('(min-width: 768px)')
                if (mediaQuery.matches) {
                    let parentHeight = parentContainer.offsetHeight;
                    container.style.maxHeight = parentHeight + 'px';
                    if (containsContainMe) {
                        containsContainMe.style.minWidth = parentHeight + 'px';
                    }
                } else {
                    container.removeAttribute('style');
                    if (containsContainMe) {
                        containsContainMe.removeAttribute('style');
                    }
                }
            }
        }

    }
});